export const environment = {
  production: true,
  paypalClientId: "AccSVOOQKHsRY2xGVAflUdZFvxA42exY55znKJMKVmy1PXRhiXT0MgFD66sIFXfy6CARRmAIgVBQUV7d",
  //API_BASE_URL: ''
};
